import { connect } from 'react-redux';
import { snoozeRequest, discardRequest } from './alert-actions';
import Alerts from '../components/alerts';

const mapStateToProps = state => ({
  alerts: state.alert.data,
  isSaving: state.alert.isSaving,
});

const mapDispatchToProps = {
  snoozeRequest,
  discardRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
